/*
 * --------------------------------------------------------------------
 * File: \src\app\authSlice.js
 * Created: Thursday, 26th September 2024 10:17:53 pm
 * Modified: Thursday, 26th September 2024 10:17:53 pm
 * Author: Mohamed Kamil Bin Mansor
 * 
 * Copyright (c) 2024 - System Consultancy Services Sdn. Bhd.
 * --------------------------------------------------------------------
 */

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    isAuthorized: sessionStorage.getItem("isAuthorized") ? sessionStorage.getItem("isAuthorized") : null, // Retrieve value from session storage
    user: sessionStorage.getItem("user") ? JSON.parse(sessionStorage.getItem("user")) : null,
  },
  reducers: {
    login(state, action) {
      state.isAuthorized = true;
      state.user = action.payload; // Store user info if needed
      sessionStorage.setItem("isAuthorized", "true"); // Store in session storage
    },
    logout(state) {
      state.isAuthorized = false;
      state.user = null;
      sessionStorage.removeItem("isAuthorized"); // Clear from session storage
    },
  },
});

export const { login, logout } = authSlice.actions;

export const getAuthorized = (state) => state.auth.isAuthorized;
export const getUser = (state) => state.auth.user;

export default authSlice.reducer;